<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Settings/ Parameter</h5>
            </template>
            <b-form-select v-model="selected" class="mb-3 tab-select">
                <b-form-select-option value=0>Bunga & Gadai</b-form-select-option>
                <b-form-select-option value=1>Biaya Admin</b-form-select-option>
                <b-form-select-option value=2>Denda & Penalti</b-form-select-option>
                <b-form-select-option value=3>Anggota</b-form-select-option>
                <b-form-select-option value=4>Administrasi</b-form-select-option>
                <b-form-select-option value=5>Mobile App</b-form-select-option>
                <b-form-select-option value=6>Emas</b-form-select-option>
                <b-form-select-option value=7>Disbursement</b-form-select-option>
                <b-form-select-option value=8>Kas Kecil</b-form-select-option>
            </b-form-select>
            <b-tabs v-model="tabIndex" class="tab-wrapper parameter-tab-wrapper" content-class="tab-content-wrapper">
                <b-tab title="BUNGA & GADAI">
                    <BungaGadai :bungaGadaiInput="input.bungaGadai"/>
                </b-tab>
                <b-tab title="BIAYA ADMIN">
                    <BiayaAdmin :biayaAdminInput="input.biayaAdmin" />
                </b-tab>
                <b-tab title="DENDA & PENALTI">
                    <DendaPenalti :dendaPenaltiInput="input.dendaPenalti" />
                </b-tab>
                <b-tab title="ANGGOTA">
                    <Anggota :anggotaInput="input.anggota" />
                </b-tab>
                <b-tab title="ADMINISTRASI">
                    <Administrasi :administrasiInput="input.administrasi" />
                </b-tab>
                <b-tab title="MOBILE APP">
                    <MobileApp :mobileInput="input.mobile" />
                </b-tab>
                <b-tab title="EMAS">
                    <Emas :emasInput="input.emas" />
                </b-tab>
                <b-tab title="DISBURSEMENT">
                    <Disbursement :disbursementInput="input.disbursement" />
                </b-tab>
                <b-tab title="KAS KECIL">
                    <KasKecil :kasKecilInput="input.kasKecil" />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import BungaGadai from '../../../components/parameter/BungaGadai';
import BiayaAdmin from '../../../components/parameter/BiayaAdmin';
import DendaPenalti from '../../../components/parameter/DendaPenalti';
import Anggota from '../../../components/parameter/Anggota';
import Administrasi from '../../../components/parameter/Administrasi';
import MobileApp from '../../../components/parameter/MobileApp';
import Emas from '../../../components/parameter/Emas.vue';
import Disbursement from '@/components/parameter/Disbursement.vue';
import KasKecil from '@/components/parameter/KasKecil.vue';

export default {
    name: 'master-parameter',
    components: {
        BungaGadai,
        BiayaAdmin,
        DendaPenalti,
        Anggota,
        Administrasi,
        MobileApp,
        Emas,
        Disbursement,
        KasKecil
    },
    watch:{
        "selected": function(newValue) {
            let result = parseInt(newValue)
            this.tabIndex = result
        },
        "tabIndex": function(newValue) {
            this.selected = newValue
        }
    },
    data(){
        return{
            initStatus: 0,
            tabIndex: 0,
            selected: 0,
            input: {
                bungaGadai: {
                    BUNGA_ELEK_1: null,
                    BUNGA_ELEK_2: null,
                    BUNGA_KEND_1: null,
                    BUNGA_KEND_2: null,
                    BUNGA_BPKB_1: null,
                    BUNGA_BPKB_2: null,
                    BONUS_BUNGA_DIDEPAN: null,
                    HARGA_TAKSIRAN: null,
                    PINJAMAN_MINIMAL: null,
                    PERSENTASE_MINIMUM_HARGA_BARANG_TERHADAP_PINJAMAN_MAKSIMAL: null,
                    MINIMUM_POKOK_AWAL: null,
                    NOTIF_KU_MIN: null,
                    NOTIF_KC_MIN: null,
                    NOTIF_KCS_MIN: null,
                    PERSENTASE_NILAI_X: null,
                    HARGA_HANDPHONE_CPU_Z: null
                },
                biayaAdmin:{
                    ADM_ELEK: null,
                    ADM_ELEK_MIN: null,
                    ADM_KEND: null,
                    ADM_KEND_MIN: null,
                    ADM_BPKB_AWAL: null,
                    ADM_BPKB_AWAL_MIN: null,
                    ADM_BPKB_BULANAN: null,
                    ADM_BPKB_BULANAN_MIN: null,
                    ADM_TV_MIN: null,
                    ADM_PAYJOY_REGIS: null,
                },
                dendaPenalti:{
                    GRACE_PERIOD: null,
                    DENDA_ELEK: null,
                    DENDA_KEND: null,
                    DENDA_BPKB: null,
                    PENALTI_ELEK: null,
                    MIN_PENALTI_ELEK: null,
                    PENALTI_KEND_MBL: null,
                    PENALTI_KEND_MBL_BULAN: null,
                    PENALTI_KEND_MTR: null,
                    PENALTI_KEND_MTR_BULAN: null,
                    PENALTI_BPKB_MBL: null,
                    PENALTI_BPKB_MBL_BULAN: null,
                    PENALTI_BPKB_MTR: null,
                    PENALTI_BPKB_MTR_BULAN: null,
                },
                anggota:{
                    MAX_GADAI_ELEK: null,
                    MAX_GADAI_KEND: null,
                    MAX_GADAI_BPKB: null,
                    MAX_GADAI_JENIS: null,
                    BONUS_GADAI_PERTAMA: null,
                    ADJUST_MACET: null,
                    ADJUST_KURANG_LANCAR: null,
                    ADJUST_LANCAR: null,
                    ADJUST_BARU: null,
                    HARI_MACET: null,
                    HARI_KURANG_LANCAR: null
                },
                administrasi:{
                    EKS_1_BARANG_HILANG: null,
                    EKS_2_BARANG_HILANG: null,
                    NOTIF_KIRIM_BALIK: null
                },
                mobile: {
                    MOBILE_LIMIT_CEK_HARGA_GADAI: null
                },
                emas: {
					BONUS_BUNGA_DIDEPAN_EMAS : null,
					HARGA_TAKSIRAN_EMAS: null,
					PINJAMAN_MINIMAL_EMAS: null,
					BATAS_BAWAH_GADAI_EMAS: null,
					BATAS_BAWAH_GADAI_EMAS_NOMINAL: null,
					ADM_EMAS: null,
					ADM_EMAS_MIN: null,
					DENDA_EMAS: null,
                    MIN_PENALTI_EMAS:null,
					PENALTI_EMAS: null,
					MAX_GADAI_EMAS: null,
					BONUS_GADAI_PERTAMA_EMAS: null,
					NOTIF_KU_MIN_EMAS: null,
					NOTIF_KC_MIN_EMAS: null,
					NOTIF_KCS_MIN_EMAS: null,
					NOTIF_PUSAT_MIN_EMAS: null,
                    BAKU_PERUSAHAAN_EMAS:0,
                    POTONGAN_PENGAIT_EMAS:0,
                    POTONGAN_KARAT_CAP_TEMPELAN:0 
                },
                disbursement: {
                    NOTIF_DISBURSE_KU_MIN: null,
                    NOTIF_DISBURSE_KC_MIN: null,
                    NOTIF_DISBURSE_KCS_MIN: null,
                    NOTIF_DISBURSE_FINANCE_MIN: null,
                    MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN: null,
                    LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU: null,
                    LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA: null,
                    LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA: null,
                },
                kasKecil: {
                    LIMIT_KAS_KECIL_KELAS_1: null,
                    LIMIT_KAS_KECIL_KELAS_2: null,
                    LIMIT_KAS_KECIL_KELAS_3: null,
                    TAMBAHAN_KAS_KECIL_UNTUK_KCU: null,
                }
            }
        }
    }, 
    methods: {
        //----------------- Fungsi Inisialisasi -----------------
        
        init(){
            this.initStatus = 0
            
            let getAllParameter = this.$axios.get(`parameter/`).then(response => {
                
                //Bunga Gadai
                this.input.bungaGadai.BUNGA_ELEK_1 = response.data.BUNGA_ELEK_1
                this.input.bungaGadai.BUNGA_ELEK_2 = response.data.BUNGA_ELEK_2
                this.input.bungaGadai.BUNGA_KEND_1 = response.data.BUNGA_KEND_1
                this.input.bungaGadai.BUNGA_KEND_2 = response.data.BUNGA_KEND_2
                this.input.bungaGadai.BUNGA_BPKB_1 = response.data.BUNGA_BPKB_1
                this.input.bungaGadai.BUNGA_BPKB_2 = response.data.BUNGA_BPKB_2
                this.input.bungaGadai.BONUS_BUNGA_DIDEPAN = response.data.BONUS_BUNGA_DIDEPAN
                this.input.bungaGadai.HARGA_TAKSIRAN = response.data.HARGA_TAKSIRAN
                this.input.bungaGadai.PINJAMAN_MINIMAL = response.data.PINJAMAN_MINIMAL
                this.input.bungaGadai.PERSENTASE_MINIMUM_HARGA_BARANG_TERHADAP_PINJAMAN_MAKSIMAL = response.data.PERSENTASE_MINIMUM_HARGA_BARANG_TERHADAP_PINJAMAN_MAKSIMAL
                this.input.bungaGadai.MINIMUM_POKOK_AWAL = this.$helper.addThousandSeparator(response.data.MINIMUM_POKOK_AWAL)
                this.input.bungaGadai.NOTIF_KU_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_KU_MIN)
                this.input.bungaGadai.NOTIF_KC_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_KC_MIN)
                this.input.bungaGadai.NOTIF_KCS_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_KCS_MIN)
                this.input.bungaGadai.PERSENTASE_NILAI_X = response.data.PERSENTASE_NILAI_X
                this.input.bungaGadai.HARGA_HANDPHONE_CPU_Z = this.$helper.addThousandSeparator(response.data.HARGA_HANDPHONE_CPU_Z)

                //Biaya Admin
                this.input.biayaAdmin.ADM_ELEK = response.data.ADM_ELEK
                this.input.biayaAdmin.ADM_ELEK_MIN = this.$helper.addThousandSeparator(response.data.ADM_ELEK_MIN)
                this.input.biayaAdmin.ADM_KEND = response.data.ADM_KEND
                this.input.biayaAdmin.ADM_KEND_MIN = this.$helper.addThousandSeparator(response.data.ADM_KEND_MIN)
                this.input.biayaAdmin.ADM_BPKB_AWAL = response.data.ADM_BPKB_AWAL
                this.input.biayaAdmin.ADM_BPKB_AWAL_MIN = this.$helper.addThousandSeparator(response.data.ADM_BPKB_AWAL_MIN)
                this.input.biayaAdmin.ADM_BPKB_BULANAN = response.data.ADM_BPKB_BULANAN
                this.input.biayaAdmin.ADM_BPKB_BULANAN_MIN = this.$helper.addThousandSeparator(response.data.ADM_BPKB_BULANAN_MIN)
                this.input.biayaAdmin.ADM_TV_MIN = this.$helper.addThousandSeparator(response.data.ADM_TV_MIN)
                this.input.biayaAdmin.ADM_PAYJOY_REGIS = this.$helper.addThousandSeparator(response.data.ADM_PAYJOY_REGIS)

                //Denda Penalti
                this.input.dendaPenalti.GRACE_PERIOD = response.data.GRACE_PERIOD
                this.input.dendaPenalti.DENDA_ELEK = response.data.DENDA_ELEK
                this.input.dendaPenalti.DENDA_KEND = response.data.DENDA_KEND
                this.input.dendaPenalti.DENDA_BPKB = response.data.DENDA_BPKB
                this.input.dendaPenalti.PENALTI_ELEK = this.$helper.addThousandSeparator(response.data.PENALTI_ELEK)
                this.input.dendaPenalti.MIN_PENALTI_ELEK = this.$helper.addThousandSeparator(response.data.MIN_PENALTI_ELEK)
                this.input.dendaPenalti.PENALTI_KEND_MBL = this.$helper.addThousandSeparator(response.data.PENALTI_KEND_MBL)
                this.input.dendaPenalti.PENALTI_KEND_MBL_BULAN = response.data.PENALTI_KEND_MBL_BULAN
                this.input.dendaPenalti.PENALTI_KEND_MTR = this.$helper.addThousandSeparator(response.data.PENALTI_KEND_MTR)
                this.input.dendaPenalti.PENALTI_KEND_MTR_BULAN = response.data.PENALTI_KEND_MTR_BULAN
                this.input.dendaPenalti.PENALTI_BPKB_MBL = this.$helper.addThousandSeparator(response.data.PENALTI_BPKB_MBL)
                this.input.dendaPenalti.PENALTI_BPKB_MBL_BULAN = response.data.PENALTI_BPKB_MBL_BULAN
                this.input.dendaPenalti.PENALTI_BPKB_MTR = this.$helper.addThousandSeparator(response.data.PENALTI_BPKB_MTR)
                this.input.dendaPenalti.PENALTI_BPKB_MTR_BULAN = response.data.PENALTI_BPKB_MTR_BULAN

                //Anggota

                this.input.anggota.MAX_GADAI_ELEK = response.data.MAX_GADAI_ELEK
                this.input.anggota.MAX_GADAI_KEND = response.data.MAX_GADAI_KEND
                this.input.anggota.MAX_GADAI_BPKB = response.data.MAX_GADAI_BPKB
                this.input.anggota.MAX_GADAI_JENIS = response.data.MAX_GADAI_JENIS
                this.input.anggota.BONUS_GADAI_PERTAMA = this.$helper.addThousandSeparator(response.data.BONUS_GADAI_PERTAMA)
                this.input.anggota.ADJUST_MACET = response.data.ADJUST_MACET
                this.input.anggota.ADJUST_KURANG_LANCAR = response.data.ADJUST_KURANG_LANCAR
                this.input.anggota.ADJUST_LANCAR = response.data.ADJUST_LANCAR
                this.input.anggota.ADJUST_BARU = response.data.ADJUST_BARU
                this.input.anggota.HARI_MACET = response.data.HARI_MACET
                this.input.anggota.HARI_KURANG_LANCAR = response.data.HARI_KURANG_LANCAR

                //Admnistrasi
                this.input.administrasi.EKS_1_BARANG_HILANG = response.data.EKS_1_BARANG_HILANG
                this.input.administrasi.EKS_2_BARANG_HILANG = response.data.EKS_2_BARANG_HILANG
                this.input.administrasi.NOTIF_KIRIM_BALIK = response.data.NOTIF_KIRIM_BALIK
                this.input.administrasi.APPROVER_CEK_GADAI_EMAS_PUSAT = response.data.APPROVER_CEK_GADAI_EMAS_PUSAT

                // Mobile
                this.input.mobile.MOBILE_LIMIT_CEK_HARGA_GADAI = response.data.MOBILE_LIMIT_CEK_HARGA_GADAI

				//Emas
				this.input.emas.BONUS_BUNGA_DIDEPAN_EMAS = response.data.BONUS_BUNGA_DIDEPAN_EMAS
				this.input.emas.HARGA_TAKSIRAN_EMAS = response.data.HARGA_TAKSIRAN_EMAS
				this.input.emas.PINJAMAN_MINIMAL_EMAS = response.data.PINJAMAN_MINIMAL_EMAS
				this.input.emas.BATAS_BAWAH_GADAI_EMAS = response.data.BATAS_BAWAH_GADAI_EMAS
				this.input.emas.BATAS_BAWAH_GADAI_EMAS_NOMINAL = this.$helper.addThousandSeparator(response.data.BATAS_BAWAH_GADAI_EMAS_NOMINAL)
				this.input.emas.ADM_EMAS = response.data.ADM_EMAS
				this.input.emas.ADM_EMAS_MIN = this.$helper.addThousandSeparator(response.data.ADM_EMAS_MIN)
				this.input.emas.DENDA_EMAS = response.data.DENDA_EMAS
				this.input.emas.PENALTI_EMAS = this.$helper.addThousandSeparator(response.data.PENALTI_EMAS)
                this.input.emas.MIN_PENALTI_EMAS = this.$helper.addThousandSeparator(response.data.MIN_PENALTI_EMAS)
				this.input.emas.MAX_GADAI_EMAS = response.data.MAX_GADAI_EMAS
				this.input.emas.BONUS_GADAI_PERTAMA_EMAS = this.$helper.addThousandSeparator(response.data.BONUS_GADAI_PERTAMA_EMAS)
				this.input.emas.NOTIF_KU_MIN_EMAS = this.$helper.addThousandSeparator(response.data.NOTIF_KU_MIN_EMAS)
				this.input.emas.NOTIF_KC_MIN_EMAS = this.$helper.addThousandSeparator(response.data.NOTIF_KC_MIN_EMAS)
				this.input.emas.NOTIF_KCS_MIN_EMAS = this.$helper.addThousandSeparator(response.data.NOTIF_KCS_MIN_EMAS)  
				this.input.emas.NOTIF_PUSAT_MIN_EMAS = this.$helper.addThousandSeparator(response.data.NOTIF_PUSAT_MIN_EMAS)  
				this.input.emas.BAKU_PERUSAHAAN_EMAS = response.data.BAKU_PERUSAHAAN_EMAS
				this.input.emas.POTONGAN_PENGAIT_EMAS = response.data.POTONGAN_PENGAIT_EMAS
				this.input.emas.POTONGAN_KARAT_CAP_TEMPELAN = response.data.POTONGAN_KARAT_CAP_TEMPELAN

                // Disbursement
                this.input.disbursement.NOTIF_DISBURSE_KU_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_DISBURSE_KU_MIN)
                this.input.disbursement.NOTIF_DISBURSE_KC_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_DISBURSE_KC_MIN)
                this.input.disbursement.NOTIF_DISBURSE_KCS_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_DISBURSE_KCS_MIN)
                this.input.disbursement.NOTIF_DISBURSE_FINANCE_MIN = this.$helper.addThousandSeparator(response.data.NOTIF_DISBURSE_FINANCE_MIN)
                this.input.disbursement.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN = this.$helper.addThousandSeparator(response.data.MAX_PENCAIRAN_DISBURSE_DITANGGUHKAN)
                this.input.disbursement.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU = this.$helper.addThousandSeparator(response.data.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_SATU)
                this.input.disbursement.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA = this.$helper.addThousandSeparator(response.data.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_DUA)
                this.input.disbursement.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA = this.$helper.addThousandSeparator(response.data.LIMIT_SALDO_KAS_VIRTUAL_CABANG_KELAS_TIGA)

                // Kas Kecil
                this.input.kasKecil.LIMIT_KAS_KECIL_KELAS_1 = this.$helper.addThousandSeparator(response.data.LIMIT_KAS_KECIL_KELAS_1)
                this.input.kasKecil.LIMIT_KAS_KECIL_KELAS_2 = this.$helper.addThousandSeparator(response.data.LIMIT_KAS_KECIL_KELAS_2)
                this.input.kasKecil.LIMIT_KAS_KECIL_KELAS_3 = this.$helper.addThousandSeparator(response.data.LIMIT_KAS_KECIL_KELAS_3)
                this.input.kasKecil.TAMBAHAN_KAS_KECIL_UNTUK_KCU = this.$helper.addThousandSeparator(response.data.TAMBAHAN_KAS_KECIL_UNTUK_KCU)
            })

            Promise.all([getAllParameter]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
    },
    created(){
        this.init()
    }
}
</script>
